import React from 'react';

import Text from 'components/shared/text';
import Container from 'components/shared/container';

const TagDescription = ({ tag }) => {
  return (
    <Container>
      <Text
        margin="0"
        width="100%"
        fontSize="18px"
        textAlign="left"
        fontWeight="bold"
        text="Description"
      />
      <Text
        width="100%"
        textAlign="left"
        lineHeight="1.5"
        margin="20px 0 40px 0"
        text={tag?.description}
      />
    </Container>
  );
};

export default TagDescription;
